import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const LandingPage = React.lazy(() => import('../pages/LandingPage'));
const LoginPage = React.lazy(() => import('../pages/LoginPage'));

const UnAuthenticatedRoutes = () => {
  return (
    <React.Fragment>
      <Routes>
        {/* <Route path='/' element={<LandingPage />} /> */}
        <Route path='/' element={<LoginPage />} />
        <Route path='*' element={<Navigate to='/' replace={true} />} />
      </Routes>
    </React.Fragment>
  );
};

export default UnAuthenticatedRoutes;
